export const GET_CLIENT_DATA = 'providers/reports/ClientData/GET_CLIENT_DATA';
export const GET_CLIENT_DETAILS = 'providers/reports/ClientData/GET_CLIENT_DETAILS';
export const GET_PAGINATION_CLIENTS = 'providers/reports/ClientData/GET_PAGINATION_CLIENTS';
export const EXPORT_CLIENTS_REPORT = 'providers/reports/ClientData/EXPORT_CLIENTS_REPORT';
export const GET_PAGINATION_DETAILS = 'providers/reports/ClientData/GET_PAGINATION_DETAILS';
